import { RenderProductDescriptionProps } from '../interface/interface';
import DOMPurify from 'dompurify';
import ShadowRoot from 'react-shadow';

export default function RenderProductDescription(
  props: Readonly<RenderProductDescriptionProps>,
) {
  if (!props?.description) return 'No description available';

  const sanitizeHtml = DOMPurify.sanitize(props.description);

  return (
    <ShadowRoot.div>
      <div dangerouslySetInnerHTML={{ __html: sanitizeHtml }} />
    </ShadowRoot.div>
  );
}
